import React, { useMemo, useRef } from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';
import axios from 'axios';
import { getToken } from '../lib/dataService';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function uploadFile(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API}/upload`, fd, {
    headers: { Authorization: `Bearer ${getToken()}` },
  });
  return res.data.url;
}

export default function RichTextEditor({ value, onChange, placeholder }) {
  const quillRef = useRef(null);

  const modules = useMemo(() => ({
    toolbar: {
      container: [
        [{ header: [2, 3, 4, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['blockquote', 'link', 'image', 'video'],
        ['clean'],
      ],
      handlers: {
        image: function () {
          const input = document.createElement('input');
          input.setAttribute('type', 'file');
          input.setAttribute('accept', 'image/*');
          input.click();
          input.onchange = async () => {
            const file = input.files && input.files[0];
            if (!file) return;
            toast.info('Uploading image...');
            try {
              const url = await uploadFile(file);
              const editor = quillRef.current && quillRef.current.getEditor();
              const range = editor.getSelection(true);
              editor.insertEmbed(range ? range.index : 0, 'image', url);
              editor.setSelection((range ? range.index : 0) + 1);
              toast.success('Image added to post');
            } catch (err) {
              toast.error(err?.response?.data?.detail || 'Image upload failed');
            }
          };
        },
      },
    },
  }), []);

  return (
    <div className="rte-wrap">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder || 'Write your story here... Use the toolbar to format text and insert photos.'}
      />
    </div>
  );
}
